import { render, staticRenderFns } from "./PrepAdherence.vue?vue&type=template&id=3dd4d50f&"
import script from "./PrepAdherence.vue?vue&type=script&lang=js&"
export * from "./PrepAdherence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports